import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class HoverStateProvider extends React.Component {
	static propTypes = {
		className: PropTypes.string,
		render: PropTypes.func
	}

	state = {
		hovered: false
	}

	handleMouseEnter = () => this.setState({ hovered: true });

	handleMouseLeave = () => this.setState({ hovered: false });

	render() {
		const { hovered } = this.state;
		const { render, className, ...restProps } = this.props;

		const blockClasses = classNames([
			'cursor-pointer',
			className
		]);

		return (
			<div
				className={blockClasses}
				onMouseEnter={this.handleMouseEnter}
				onMouseLeave={this.handleMouseLeave}>
				{ render({ hovered, ...restProps }) }
			</div>
		);
	}
}
